import MainLayout from "@/components/layouts";
import { CONTACT_PROPERTIES_TITLE, contactPropertiesAppointmentPath } from "@/lib/property-contact-scope";
import { ContactPropertyAppointments } from "./contact-property-appointments";

export default function ContactPropertiesPage() {
  return (
    <MainLayout breadcrumb={[{ name: CONTACT_PROPERTIES_TITLE, href: "#" }]}>
      <ContactPropertyAppointments note="Appointments at these properties are here to read. They aren't your organization's work." appointmentHref={contactPropertiesAppointmentPath} />
    </MainLayout>
  );
}
